<template>
<div class="ti">
  <div>
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">导入名称</th>
            <th class="text-left">归属项目</th>
            <th class="text-left">类型</th>
            <th class="text-left">状态</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.Import_name}}</td>
            <td >{{item.cname}}</td>
            <td ><span v-if="item.type == 1">住宅</span><span v-if="item.type == 2">车位</span><span v-if="item.type == 3">储藏室</span><span v-if="item.type == 4">商铺</span></td>
            <td ><span v-if="item.state == 1">未审核</span><span v-if="item.state == 2">已通过</span><span v-if="item.state == 3">已拒绝</span></td>
            <td >{{item.date}}</td>
            <td class="cdj_td">
                <div style="color: #0074D9;cursor: pointer;" @click="xhazai(item.route)">下载</div>
                <div style="color: #0074D9;cursor: pointer;margin-left: 5px;" @click="adopt(item.id)" v-if="item.state != 2 && item.state != 3">通过</div>
                <div style="color: red;cursor: pointer;margin-left: 5px;" @click="refuse(item.id)" v-if="item.state != 2 && item.state != 3">拒绝</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
</div>

</template>

<script>
export default {
  name: 'pindexExamine',
  data () {
    return {
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
      loading:false,
    }
  },
  //界面没出来前加载
  created() {

  },
  // 加载数据
  mounted(){
    this.$Loading.start();
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/examine?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //获得当前多少页,分页
    change(e){
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/examine?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //搜索
    searchs(){
      this.$Loading.start();
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/examine?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
      });
    },
    //下载文件审核
    xhazai(e){
      var url = this.$myhttp.defaults.baseURL+"/"+e;
      window.open(url)
    },
    //拒接
    refuse(e){
      var id = {'id':e};
      this.loading = true;
      this.$myhttp.post('admin/examineExcelRefuse',id,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.$myhttp.get('admin/examine?id=1'+'&company='+this.value +'&company1='+this.value1+"&distinguish=0",{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
                this.loading=false;
            });
             this.$Message.success('操作成功!');
      });
    },
    //通过审核
    adopt(e){
      var id = {'id':e};
      this.loading = true;
      this.$myhttp.post('admin/examineAdopt',id,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
            this.$myhttp.get('admin/examine?id=1'+'&company='+this.value +'&company1='+this.value1+"&distinguish=0",{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            //房产导入数据开始
            this.$myhttp.post('admin/importStart',id,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
                this.loading = false;
                if(backdata.data.code == 201){
                  this.$Message.success('导入失败!');
                  return false;
                }
                this.$Message.success('导入成功!');
                //抽分类
                this.$myhttp.post('admin/classification',id,{
                'Content-Type': 'application/x-www-form-urlencoded'
                }).then(backdata=>{ // 异步执行成功后

                });

            });

      });
    }
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path == "/pindex/Examine"){
       //加载项目列表
        this.$Loading.start();
        this.$myhttp.get('admin/examine?id=1'+'&company='+this.value +'&company1='+this.value1+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
            this.$Loading.finish();
        });
      }
    }
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.el-button{
    color: rgb(252, 247, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Examine.vue